/**
 * Constructs a URL-safe slug from a string value.
 * Matches the slug creation logic used in the CMS (StringUtils.php).
 */
export function constructSlug(value: string): string {
  return value
    .replace(/[^a-zA-Z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
}

type HasVariantFields = {
  description: string;
  isbaseoption?: boolean | null;
};

function findBaseVariant<T extends HasVariantFields>(vehicles: T[]): T | undefined {
  return vehicles.find((v) => v.isbaseoption === true) ?? vehicles[0];
}

/**
 * Selects a vehicle variant from a list.
 *
 * When `variantSlug` is provided, returns the vehicle whose description
 * matches the slug. Falls back to the base variant if no match is found.
 *
 * When absent, returns the base variant (first vehicle where
 * `isbaseoption === true`, or the first vehicle in the array).
 */
export function selectVariant<T extends HasVariantFields>(vehicles: T[], variantSlug?: string): T | undefined {
  if (vehicles.length === 0) return undefined;

  if (!variantSlug) return findBaseVariant(vehicles);

  const matched = vehicles.find((v) => constructSlug(v.description) === variantSlug);
  return matched ?? findBaseVariant(vehicles);
}
